import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { AuthProvider } from './components/AuthProvider';
import { ThemeProvider } from './context/ThemeContext';
import { isPermissionPreview } from './services/permissionPreviewSession';
import './index.css';

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
const PublicTicketSignaturePage = React.lazy(() => import('./pages/TicketSignaturePage'));
// External signers must never bootstrap, refresh, or restore a FORXA account session.
const isPublicTicketSignature = window.location.pathname.replace(/\/+$/, '') === '/sign-ticket';
root.render(
  isPublicTicketSignature ? (
    <ThemeProvider preference="system">
      <React.Suspense fallback={<p className="p-6">Loading / Cargando…</p>}>
        <PublicTicketSignaturePage />
      </React.Suspense>
    </ThemeProvider>
  ) : (
    <AuthProvider><App /></AuthProvider>
  ),
);

if (!isPermissionPreview() && process.env.NODE_ENV === 'production' && 'serviceWorker' in navigator) {
  // Register after the page has loaded so the worker's install requests don't
  // compete with the app's own first-load bundles and API calls. The offline
  // drawings download flow (ensureDrawingOfflineRuntimeReady) registers and
  // waits for the worker itself, so it never depends on this early path.
  const registerServiceWorker = () => {
    void navigator.serviceWorker.register('/service-worker.js').catch((error) => {
      console.warn('[PWA] Service worker registration failed:', error);
    });
  };
  if (document.readyState === 'complete') registerServiceWorker();
  else window.addEventListener('load', registerServiceWorker, { once: true });
}
